import React, { useState, useEffect } from "react";
import NotificationItem from './NotificationItem';
import { smallTextSkeleton, mediumTextSkeleton } from '../../../Templates/icons';

const LatestNotifications = (props) => {
   const [isLoading, setIsLoading] = useState(true);
   const [notifications, setNotifications] = useState([]);
   const [showAllNotifications, setShowAllNotifications] = useState(true);

   useEffect(() => {
    const fetchNotifications = async () => {
        // Only fetch if not from bell (widget case)
        if (!props.fromBell) {
            const fetchedNotifications = await props.fetchNotifications(false);
            setNotifications(fetchedNotifications);
        } else {
            // Use the passed notifications directly for bell
            setNotifications(props.notifications);
            // Reset to show all notifications when opening the bell
            //setShowAllNotifications(true);
        }
        setIsLoading(false);
    };

    fetchNotifications();
    document.addEventListener('click', handleClickOutside);

    return () => document.removeEventListener('click', handleClickOutside);
   }, [props.currentUserId, props.notifications, props.fromBell]);

    const handleClickOutside = (event) => {
        if (props.fromBell) {
            let inside = false;
            event.composedPath().forEach(item => {
               // Check for notification popup IDs
               if (item.id === "pop-up-notifications" || item.id === "pop-up-notification") {
                    inside = true;
                    return;
                }
               // Check for modal elements (Material-UI modals)
               if (item.classList && item.classList.contains('MuiModal-root')) {
                    inside = true;
                    return;
                }
               // Check for modal backdrop
               if (item.classList && item.classList.contains('MuiBackdrop-root')) {
                    inside = true;
                    return;
                }
               // Check for any element with modal-related classes
               if (item.className && typeof item.className === 'string' && 
                   (item.className.includes('modal') || item.className.includes('Modal'))) {
                    inside = true;
                    return;
                }
            });
            if (!inside) {
                // Filter to only show notifications from the past week
                setShowAllNotifications(false);
                props.toggleNotifications();
            }
        }
    };

    const ghostItem = <div className="flex">
        <div className="flex-column max-width" style={{ marginTop: "1.5em", marginLeft: "1em" }}>
            <div className="flex-apart" style={{ width: "95%" }}>
                {mediumTextSkeleton}
                {smallTextSkeleton}
            </div>
        </div>
    </div>;

    return ( 
        isLoading ? 
            <div className={props.fromBell ? "widget-notifications" : "feed-item shadow"}>
                <h2 className="feed-notification-header FontSize20" style={props.fromBell ? { background: "#F7FAFC", color: "#042763" } : null}> 
                    {props.fromBell ? "UNREAD NOTIFICATIONS" : "LATEST NOTIFICATION"} 
                </h2>
                <div className="feed-all-notifications-container overflow-y">
                    <ul className="feed-database-notifications-container flex-column overflow-y overflow-x-hidden">
                        {ghostItem}
                        {ghostItem}
                        {ghostItem}
                        {ghostItem}
                        {ghostItem}
                        {ghostItem}
                    </ul>
                </div>
            </div> 
        : 
            <div className={props.fromBell ? "shadow widget-notifications" : "shadow feed-item"}>
                <h2 className="feed-notification-header FontSize20" style={props.fromBell ? { background: "#F7FAFC", color: "#042763" } : null}> 
                    {props.fromBell ? "UNREAD NOTIFICATIONS" : "LATEST NOTIFICATION"} 
                </h2>
                <div className="feed-all-notifications-container overflow-y overflow-x-hidden">
                    <ul className="feed-database-notifications-container">
                        {Array.isArray(notifications) && 
                            (() => {
                                let sortedNotifications = [...notifications]
                                    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                                
                                // Filter to only show notifications from the past week if showAllNotifications is false
                                if (!showAllNotifications) {
                                    const oneWeekAgo = new Date();
                                    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
                                    
                                    sortedNotifications = sortedNotifications.filter(notification => {
                                        const notificationDate = new Date(notification.createdAt);
                                        return notificationDate >= oneWeekAgo;
                                    });
                                }
                                    
                                return (props.fromBell ? 
                                    sortedNotifications.map(notification => (
                                        <NotificationItem
                                            key={notification._id}
                                            message={notification.message}
                                            createdAt={notification.createdAt}
                                            read={notification.read}
                                            module={notification.module}
                                            sender={notification.sender}
                                            process={notification.process}
                                        />
                                    ))
                                    : 
                                    sortedNotifications.map(notification => (
                                        <NotificationItem
                                            key={notification._id}
                                            message={notification.message}
                                            createdAt={notification.createdAt}
                                            read={notification.read}
                                            module={notification.module}
                                            sender={notification.sender}
                                            process={notification.process}
                                        />
                                    ))
                                );
                            })()
                        }
                    </ul>
                </div>
            </div>
    );
};

export default LatestNotifications;